import React from "react"
import { Link } from "react-router-dom"
import shape1 from "../../images/shape/map-shape1.png"
import shape4 from "../../images/shape/vector-shape4.png"
import shape5 from "../../images/shape/vector-shape5.png"
import DynamicImage from "../common/DynamicImage"
import { HighlightText } from "../common/HighlightText"

const TeamMembers = ({ data }) => {
  return (
    <>
      <div className="scientist-area ptb-70 contact-team-area">
        <div className="container">
          <div className="row align-items-center gy-4">
            <div className="col-lg-7 col-md-12 order-2 order-lg-1">
              <div className="scientist-box-list">
                <div className="row">
                  {data?.image?.slice(0, 3).map((img, index) => (
                    <div
                      key={img.id}
                      className={`col-lg-6 col-sm-6 col-md-6 
                      ${index === 0 ? "offset-lg-1" : ""}
                      ${index === 2 ? "offset-lg-0 offset-md-3" : ""}`}
                    >
                      <div className="single-scientist-item">
                        <DynamicImage image={img} />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="map-shape1">
                  <img src={shape1} alt="banner" />
                </div>
                <div className="vector-shape5">
                  <img src={shape5} alt="banner" />
                </div>
              </div>
            </div>

            <div className="col-lg-5 col-md-12 order-1 order-lg-2">
              <div className="scientist-section-title">
                {data?.title && <h2><HighlightText content={data?.title} /></h2>}
                {data?.description?.map((block, index) => {
                  switch (block.type) {
                    case "paragraph":
                      return (
                        <p key={index}>
                          <HighlightText content={block.children.map(c => c.text).join("")} />
                        </p>
                      );

                    case "heading":
                      const Tag = `h${block.level}`;
                      return (
                        <Tag key={index} className="mt-4 mb-3">
                          <HighlightText content={block.children.map(c => c.text).join("")} />
                        </Tag>
                      );

                    case "list":
                      return (
                        <ul key={index} className="list-unstyled">
                          {block.children.map((item, i) => (
                            <li key={i} className="features-text">
                              <h4>
                                <i className="flaticon-tick"></i>{" "}
                                {item.children.map(c => c.text).join("")}
                              </h4>
                            </li>
                          ))}
                        </ul>
                      );

                    default:
                      return null;
                  }
                })}
                {data?.secButton && (
                  <Link
                    to={data.secButton.url}
                    target="_blank"
                    className="default-btn"
                  >
                    <i className="bx bx-support"></i>
                    {data.secButton.label}
                    <span className="default-btn-hover"></span>
                  </Link>
                )}

              </div>
            </div>
          </div>
        </div>

        <div className="vector-shape4">
          <img src={shape4} alt="banner" />
        </div>
      </div>
    </>
  )
}

export default TeamMembers
